import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {Generic3FieldForm} from ".";

type PreviewProps = {
    test: Test
}

export class Generic3FieldRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <Generic3FieldForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}